import { render, staticRenderFns } from "./InfoModal.vue?vue&type=template&id=7b77cdfb"
import script from "./InfoModal.vue?vue&type=script&lang=js"
export * from "./InfoModal.vue?vue&type=script&lang=js"
import style0 from "./InfoModal.vue?vue&type=style&index=0&id=7b77cdfb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports